<div class="d-flex align-items-center justify-content-center p-3 flex-column h-100">
  <span>Are you sure you want to delete this saved search?</span>
  <div class="pt-3">
    <button mat-flat-button color="primary" [mat-dialog-close]="true">Yes</button>
    <button mat-button [mat-dialog-close]="false">No</button>
  </div>
</div>
